import React, { Component } from "react";
import { Table } from "semantic-ui-react";

class FilaResultado extends Component {
  handleClick = () =>
    this.props.handleCambiarResultado({
      idAccion: this.props.idAccion,
      resultado: this.props.resultado
    });

  render() {
    const { resultado } = this.props;
    return (
      <Table.Row onClick={this.handleClick}>
        <Table.Cell>{resultado}</Table.Cell>
      </Table.Row>
    );
  }
}

export default FilaResultado;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/tablaColegios/filaColegios/tablaAcciones/filaAcciones/tablaResultados/FilaResultado.jsx